import type { ColumnDef } from '@tanstack/react-table';
import type { TestListItem } from '~/server/api/routers/test';
import TimeAgo from '../../time/TimeAgo';

export const recentTestColumns: ColumnDef<TestListItem>[] = [
  {
    id: 'name',
    accessorFn: (row) => row.name,
    header: 'Name',
    size: 400,
    enableSorting: false,
    cell: ({ row }) => <div className="py-1.5 font-medium hover:text-blue-400">{row.original.name}</div>,
  },
  {
    id: 'createdAt',
    accessorFn: (row) => row.createdAt,
    header: 'Created',
    enableSorting: false,
    cell: ({ row }) => <TimeAgo time={row.original.createdAt} />,
  },
];
